export enum BACKGROUND_COLOR_CONSTANTS {
    DANGER = 'bg-danger',
    WARNING = 'bg-warning',
    INFO = 'bg-info',
    SUCCESS = 'bg-success',
}
